import React, {useRef, useState} from 'react';
import {Grid, Paper} from '@mui/material';
import useClickOutsideRef from '../../hooks/useClickOutsideRef';
import PlacesAutocompleteInputMui from '../placesAutocomplete/PlacesAutocompleteInputMui';
import {PlacePrediction} from '../placesAutocomplete/interfaces';
import './style.css'
import {styled} from "@mui/material/styles";

const LandingSearchInputPaper = styled(Paper)(() => ({
  height: '4.6428571428571428em',
}));

const LandingSearchInputForm = styled('form')(() => ({
  margin: '0 1.75em 0 1.75em',
}));

interface LandingSearchInputProps {
  name: string;
  selectedPacItem: PlacePrediction | undefined;
  handleClickPac: (pacItem: PlacePrediction) => void;
  handleSelectPac: (pacItem: PlacePrediction | undefined) => void;
  onSearchSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

const LandingSearchInput = (props: LandingSearchInputProps) => {
  const {
    name,
    selectedPacItem,
    handleClickPac,
    handleSelectPac,
    onSearchSubmit,
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState('');
  const [showPac, setShowPac] = useState(false);

  const handleOnFocus = () => {
    setShowPac(true);
  }

  useClickOutsideRef(containerRef, () => {
    setShowPac(false);
  });

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearchSubmit(event);
  }

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  }

  const handleCancelIconClick = () => {
    setValue('');
  }

  return <Grid container
               direction={'row'}
               justifyContent={'center'}
               onFocus={handleOnFocus}
               className='search_input'
  >
    <Grid className='text_input' item xs={6} lg={4}
          ref={containerRef}>
      <LandingSearchInputPaper>
        <Grid container
              direction={'column'}
              wrap={'nowrap'}
              justifyContent={'space-evenly'}
              alignItems={'stretch'}
              className={'h-100'}
        >
          <Grid item>
            <LandingSearchInputForm onSubmit={handleOnSubmit}>
              <PlacesAutocompleteInputMui name={name}
                                          value={value}
                                          onChange={handleValueChange}
                                          selectedPacItem={selectedPacItem}
                                          handleClickPac={handleClickPac}
                                          handleSelectPac={handleSelectPac}
                                          onCancelIconClick={handleCancelIconClick}
                                          containerRef={containerRef}
                                          showPac={showPac}
                                          autoFocus
              />
            </LandingSearchInputForm>
          </Grid>
        </Grid>
      </LandingSearchInputPaper>
    </Grid>
  </Grid>
}

export default LandingSearchInput;
